
const stageSorter = (array_to_sort, main_key) => {

        //unique stage names with alphanumeric values
        const x = array_to_sort.reduce((ret_val, o)  =>  { ret_val.indexOf(o[main_key]) == -1 ? ret_val.push(o[main_key]) : null ; return ret_val } ,[])		      

        //unique project names
        const unique_projects = x.reduce( (ret_val, o, i )  =>  { ret_val.indexOf(o.split(" - ")[0]) < 0 ? ret_val.push(o.split(" - ")[0]) : null ; return ret_val } ,[])

        //used to populate all key_value pairs back into output array after  sorting is completed on main_key
        const object_ptoperties = Object.keys(array_to_sort[0])

        //check if this is a stage array
        let  sorted_array_names_only
        let is_a_stage_name_array = array_to_sort[0][main_key].includes("Stage")

if(is_a_stage_name_array) {
        unique_projects.forEach( p => {
                const all_stages = x.filter( el => (el.includes(p)))
                sorted_array_names_only =  sort_stages_in_a_project(all_stages)
        })
} else {
                        sorted_array_names_only = x.sort()  //simple sort if this is a project array
        }

        // console.log('sorted_array_names_only: ' + JSON.stringify(sorted_array_names_only))

        const sorted_array_full_data = []
        console.log('sorted_array_names_only.length: ' + sorted_array_names_only.length)
        sorted_array_names_only.map( s => {
                        let arr_element = array_to_sort.find((a) => (is_a_stage_name_array && a[main_key] === s.full_text || !is_a_stage_name_array && a[main_key] === s))
                        // console.log('arr_element: ' + JSON.stringify(arr_element))
                        if(arr_element != null) {
                                        let new_obj = {}
                                        object_ptoperties.forEach ( o => {
                                                        new_obj[o] = arr_element[o]
                                        })         
                                        sorted_array_full_data.push(new_obj)
                        }
        })

        // console.log('sorted_array_full_data: ' + JSON.stringify(sorted_array_full_data))
                
        return sorted_array_full_data
}


const sort_stages_in_a_project = (x) => {
const  y = x.reduce( (ret_val, o, i )  =>  {  ret_val.push({ "index" : i, "full_text" : o, "projectnametext" :   o.substring(0, o.indexOf("- Stage ")-1) , "alphanumeric": o.substring(o.indexOf("- Stage ")+8)}); return ret_val } ,[])
// console.log('y: ' + JSON.stringify(y))
let  z = []
let max_elements = 0
y.map ( el => {
        let obj = {}
        obj = {...el}
        getNumericFromAlphamumeric(el.alphanumeric).map( (a, i )  => { 
                obj["e"+i] = isNaN(a) ? a : parseInt(a)
                max_elements = i > max_elements ? i : max_elements
        })
        z.push(obj)
})
console.log('max_elements: ' + max_elements)
// console.log('z: ' + JSON.stringify(z))


let unique_texts_to_sort = {}
for (var j =0; j<= max_elements ; j++ ) {
        let temp_array = []
                z.map( element  =>  { 
                        if(element["e"+j]) {
                                if(temp_array.indexOf(element["e"+j]) < 0) {
                                        temp_array.push(isNaN(element["e"+j]) ? element["e"+j] : parseInt(element["e"+j]))
                                }
                        }
                })
                unique_texts_to_sort["e"+j] = temp_array.sort(function(a, b) {return a - b;})
}

console.log('unique_texts_to_sort: ' + JSON.stringify(unique_texts_to_sort))

let final_array = []
if( max_elements == 0) {
                        let elements_with_common_first_part_SORTED = []
                        elements_with_common_first_part_SORTED = z.sort(sortArrayOfObjects(["e0"]))
                        final_array.push(...elements_with_common_first_part_SORTED)
} 

// console.log('final_array 1 : ' + JSON.stringify(final_array))
// console.log('final_array 1 length : ' + final_array.length)

                                                
        for(let ctr=0; ctr< unique_texts_to_sort["e0"].length;ctr++) { //fix output array.length > input array length
        //for(let ctr=0; ctr< max_elements;ctr++) {  //fix output array.length > input array length
                        const elements_with_common_first_part = z.reduce( (ret_val, o, i )  =>  { o["e0"] == unique_texts_to_sort["e0"][ctr] ? ret_val.push(o) : null;return ret_val } ,[])
                        let elements_with_common_first_part_SORTED = []
                        for(var k =1 ; k <=max_elements ; k++ ) {
                                        elements_with_common_first_part_SORTED = elements_with_common_first_part.sort(sortArrayOfObjects(["e"+k]))
                        }
                        final_array.push(...elements_with_common_first_part_SORTED)
}

// console.log('final_array 2 : ' + JSON.stringify(final_array))
// console.log('final_array 2 length : ' + final_array.length)

        //MOST IMPORTANT CONSOLE LOG FOR SANITY CHECK - COMMENT FOR POC
        console.log('total elements in input array : ' + x.length )
        console.log('final_array.length : ' + final_array.length )
        
return  final_array
}



const getNumericFromAlphamumeric = (alpha_numeric) => {
let stage_number = "", stage_text = "", i =0, text_found = false, number_found=false, stage_array = []
do {
        if(isNaN(alpha_numeric[i])) {
                text_found = true
                if (number_found) {
                        stage_array.push(parseInt(stage_number))
                        number_found = false
                        stage_number = ""
                }
                stage_text = stage_text = stage_text + alpha_numeric[i]
        } else {
                number_found = true
                if (text_found) {
                        stage_array.push(stage_text)
                        text_found = false
                        stage_text = ""
                }
                stage_number = stage_number+alpha_numeric[i]
        }
        i++
} while( i <= alpha_numeric.length-1) 
stage_array.push(number_found ? stage_number : stage_text)
return stage_array
}


const sortArrayOfObjects = (property, order) => {  
        return function(a,b){  
                        if(order='asc') {
                                        if(a[property] > b[property])  
                                        return 1;  
                        else if(a[property] < b[property])  
                                        return -1;  
                        } else {
                                        if(a[property] < b[property])  
                                                        return 1;  
                                        else if(a[property] > b[property])  
                                                        return -1;  
                        }

                        return 0;  
        }  
}

export default stageSorter